import axios  from "../../utils/axios";

export const create_suppliers = async (payload) => {
    const response = await axios.post(`/admin/suppliers`, payload);
    const {data} = response;

    return data;
};

export const get_all_suppliers = async () => {
    const response = await axios.get(`/admin/suppliers`);
    const {data} = response;

    return data;
};

export const update_supplier = async (id, payload) => {
    const response = await axios.put(`/admin/suppliers/${id}`, payload);
    const {data} = response;

    return data;
};

export const delete_suppliers = async (id) => {
    const response = await axios.delete(`/admin/suppliers/${id}`, );
    const {data} = response;

    return data;
};